<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-top-transition"
    max-width="1200"
    persistent
  >
    <v-card>
      <v-toolbar color="blue" dark><h4>Datos del Reporte</h4></v-toolbar>
      <template>
        <v-data-table
          :headers="headersTablaMaterial"
          :items="tablaMateriales"
          :search="buscarMateriales"
          :custom-filter="headersTablaMaterial"
          class="elevation-1 mt-0"
          no-results-text="No se encontraron resultados"
          no-data-text="No ha cargado Ningun Dato"
          :footer-props="$store.state.traduccionTabla"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Lista de Materiales</v-toolbar-title>
            </v-toolbar>
          </template>
        </v-data-table>
      </template>

      <template>
        <v-data-table
          :headers="headersTablaMaterialBobinas"
          :items="tablaMaterialesBobinas"
          :search="buscarMaterialesBobinas"
          :custom-filter="headersTablaMaterialBobinas"
          class="elevation-1 mt-0"
          no-results-text="No se encontraron resultados"
          no-data-text="No ha cargado Ningun Dato"
          :footer-props="$store.state.traduccionTabla"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Lista de Bobinas</v-toolbar-title>
            </v-toolbar>
          </template>

          <template v-slot:item.customCantidad="{ item }">
            {{ item.secFin - item.secInicio }}
          </template>
        </v-data-table>
      </template>

      <template>
        <v-data-table
          :headers="headersTablaMaterialMedidores"
          :items="tablaMaterialesMedidores"
          :search="buscarMaterialesMedidores"
          :custom-filter="headersTablaMaterialMedidores"
          class="elevation-1 mt-0"
          no-results-text="No se encontraron resultados"
          no-data-text="No ha cargado Ningun Dato"
          :footer-props="$store.state.traduccionTabla"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Lista de Medidores</v-toolbar-title>
            </v-toolbar>
          </template>
        </v-data-table>
      </template>

      <v-card-actions class="justify-end">
        <v-btn title="Cerrar" color="red" dark @click="cerrarDialog()"
          ><v-icon>mdi-close-circle</v-icon>Cerrar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import moment from "moment";
export default {
  data() {
    return {
      dialog: false, //ESTE MODAL
      elemento: {}, //OBJETO DE RECLAMO
      tipoConsulta: 0,
      headersTablaMaterial: [
        { text: "Matricula", value: "idMaterial", class: "black white--text" },
        {
          text: "Descripcion",
          value: "nombre",
          class: "black white--text",
        },
        {
          text: "Cantidad",
          value: "cantidad",
          class: "black white--text",
        },
        //{ text: "Motivo", value: "motivo" },
        //{ text: "Acciones", value: "actions", sortable: false },
      ],
      headersTablaMaterialBobinas: [
        { text: "Bobina", value: "idBobinaT", class: "black white--text" },
        {
          text: "Secuencia de Inicio",
          value: "secInicio",
          class: "black white--text",
        },
        {
          text: "Secuencia de Fin",
          value: "secFin",
          class: "black white--text",
        },
        {
          text: "Cantidad De Metros",
          value: "customCantidad",
          class: "black white--text",
        },
        //{ text: "Motivo", value: "motivo" },
        //{ text: "Acciones", value: "actions", sortable: false },
      ],
      headersTablaMaterialMedidores: [
        { text: "Matricula", value: "idMaterial", class: "black white--text" },
        {
          text: "Codigo Medidor",
          value: "idMedidor",
          class: "black white--text",
        },
        {
          text: "Nombre",
          value: "descripcionMedidor",
          class: "black white--text",
        },
      ],
    };
  },

  methods: {
    ...mapActions("reclamos", ["ObtenerDetalleReclamoPorId"]),
    //LIMPIA LOS CAMPOS
    async LimpiarCampos() {
      this.elemento.barrio = "";
      this.elemento.comentario = "";
      this.elemento.contratista = "";
      this.elemento.detalle = "";
      this.elemento.distrito = "";
      this.elemento.domicilio = "";
      this.elemento.identificador = "";
      this.elemento.indice = "";
      this.elemento.isn = "";
      this.elemento.mail = "";
      this.elemento.medidor = "";
      this.elemento.motivo = "";
      this.elemento.radio = "";
      this.elemento.recorrido = "";
      this.elemento.telefono = "";
      this.elemento.titular = false;
      this.elemento.vencimiento = false;
    },
    //ABRE EL MODAL

    cerrarDialog() {
      this.tipoConsulta = 0;
      this.dialog = false;
    },

    async getDetallesRemitoMateriales(idRemito) {
      console.log("Ingreso en los detalles del cajon");
      this.url =
        this.$store.getters.urlBase +
        "Material/recuperarRemitoMateriales?idRemito=" +
        idRemito;

      this.listaMaterialesCajon = [];
      this.listaMaterialesOriginales = [];
      //this.cajones = listaCajon;
      console.log(this.url);
      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperar materiales cajon");
          console.log(response.data);
          this.listaMaterialesCajon = response.data;
          console.log(this.listaMaterialesCajon);
          return response.data;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      // this.tablaMaterialesCajonModificacion = respuesta;
      // this.listaMaterialesCajon = respuesta;
      // this.loadingButton = false;
      // respuesta.forEach((material) => {
      //   this.listaMaterialesOriginales.push({
      //     idMaterial: material.idMaterial,
      //     cantidad: material.cantidadSaldo,
      //   });
      // });

      // console.log("Lo que hay en la tabla Materiales para la modificacion es");
      // console.log(this.tablaMaterialesCajonModificacion);

      // console.log("Los materiales originales son: ");
      // console.log(this.listaMaterialesOriginales);

      return respuesta;
    },

    async getDetallesRemitoMaterialesMedidores(idRemito) {
      console.log("Ingreso en los detalles del materiales bobinas");
      this.url =
        this.$store.getters.urlBase +
        "Material/recuperarRemitoMaterialesMedidores?idRemito=" +
        idRemito;

      this.listaMaterialesCajon = [];
      this.listaMaterialesOriginales = [];
      this.listaMaterialesOriginales = [];
      //this.cajones = listaCajon;
      console.log(this.url);
      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperar medidores");
          console.log(response.data);
          this.tablaMaterialesMedidores = response.data;
          console.log(this.tablaMaterialesMedidores);
          return response.data;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      return respuesta;
    },

    async getDetallesRemitoMaterialesBobinas(idRemito) {
      console.log("Ingreso en los detalles del materiales bobinas");
      this.url =
        this.$store.getters.urlBase +
        "Material/recuperarRemitoMaterialesBobinas?idRemito=" +
        idRemito;

      this.listaMaterialesCajon = [];
      this.listaMaterialesOriginales = [];
      //this.cajones = listaCajon;
      console.log(this.url);
      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperar bobinas remito");
          console.log(response.data);
          this.tablaMaterialesBobinas = response.data;
          console.log(this.tablaMaterialesBobinas);
          return response.data;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      return respuesta;
    },

    async verDetalleReporte(reporteSeleccionado) {
      var materiales = await this.getDetallesRemitoMateriales(
        reporteSeleccionado.idRemito
      );
      var materialesBobina = await this.getDetallesRemitoMaterialesBobinas(
        reporteSeleccionado.idRemito
      );

      var materialesMedidor = await this.getDetallesRemitoMaterialesMedidores(
        reporteSeleccionado.idRemito
      );

      this.tablaMateriales = materiales;

      this.tablaBobinas = materialesBobina;

      this.tablaMedidores = materialesMedidor;

      this.dialog = true;
    },

    async AbrirModalDatosReportes(datos) {
      this.tipoConsulta = 1;
      await this.LimpiarCampos();
      console.log("Los datos son:");

      console.log(datos);

      (this.elemento.barrio = datos.barrio),
        (this.elemento.comentario = datos.comentario),
        (this.elemento.contratista = datos.contratista),
        (this.elemento.detalle = datos.detalle),
        (this.elemento.distrito = datos.distrito),
        (this.elemento.domicilio = datos.domicilio),
        (this.elemento.identificador = datos.identificador),
        (this.elemento.indice = datos.indice),
        (this.elemento.isn = datos.isn),
        (this.elemento.mail = datos.mail),
        (this.elemento.medidor = datos.medidor),
        (this.elemento.motivo = datos.motivo),
        (this.elemento.radio = datos.radio),
        (this.elemento.recorrido = datos.recorrido),
        (this.elemento.telefono = datos.telefono),
        (this.elemento.titular = datos.titular);
      this.elemento.vencimiento = datos.vencimiento;
      this.elemento.idTarea = datos.idTarea;
      this.elemento.nombreUsuario = datos.nombreUsuario;
      this.elemento.descripcionMotivo = datos.descripcionMotivo;

      console.log(this.elemento);

      var respuesta = "";

      this.url =
        this.$store.state.urlBase +
        "Material/recuperarMaterialesUtilizadosInspeccion?idTarea=" +
        this.elemento.idTarea;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      respuesta = await axios
        .get(this.url, config)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de la tarea cancelada es:");

      this.tablaMaterialesUtilizadosInspeccion = respuesta;

      console.log(this.tablaMaterialesUtilizadosInspeccion);

      this.dialog = true;
    },

    async AbrirModal(datos) {
      await this.LimpiarCampos();
      console.log("Los datos son:");

      console.log(datos);

      (this.elemento.barrio = datos.barrio),
        (this.elemento.comentario = datos.comentario),
        (this.elemento.contratista = datos.contratista),
        (this.elemento.detalle = datos.detalle),
        (this.elemento.distrito = datos.distrito),
        (this.elemento.domicilio = datos.domicilio),
        (this.elemento.identificador = datos.identificador),
        (this.elemento.indice = datos.indice),
        (this.elemento.isn = datos.isn),
        (this.elemento.mail = datos.mail),
        (this.elemento.medidor = datos.medidor),
        (this.elemento.motivo = datos.motivo),
        (this.elemento.radio = datos.radio),
        (this.elemento.recorrido = datos.recorrido),
        (this.elemento.telefono = datos.telefono),
        (this.elemento.titular = datos.titular);
      this.elemento.vencimiento = datos.vencimiento;

      console.log(this.elemento);

      // this.elemento = this.$store.state.reclamos.reclamo;
      // console.log(this.elemento);
      // this.elemento.fechaTomado = moment(this.elemento.fechaTomado).format(
      //   "DD/MM/yyyy HH:mm"
      // );
      // if (this.elemento.peligro === "SI") {
      //   this.elemento.peligro = true;
      // } else {
      //   this.elemento.peligro = false;
      // }
      // if (this.elemento.artefactosQuemados === "SI") {
      //   this.elemento.artefactosQuemados = true;
      // } else {
      //   this.elemento.artefactosQuemados = false;
      // }
      // if (this.elemento.afectaVarios === "SI") {
      //   this.elemento.afectaVarios = true;
      // } else {
      //   this.elemento.afectaVarios = false;
      // }
      // if (this.elemento.vip === "SI") {
      //   this.elemento.vip = true;
      // } else {
      //   this.elemento.vip = false;
      // }
      // console.log(this.elemento);
      /*this.elemento.barrio =
        this.elemento.codigoBarrio + " - " + this.elemento.barrio;*/

      this.dialog = true;
    },
  },
};
</script>
